
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/investments",
      function () {
        return require("private-next-pages/home/investments/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/investments"])
      });
    }
  